<template>
    <ScrollableVueCard :title="title" :chip="alarmasPendientes.length.toString()">
    <v-data-table
      item-key="name"
      hide-default-header
      :headers="[]"
      :items="[]"
      hide-default-footer
      :single-select="true"
    >
    
    <template v-slot:body>
        <tbody v-if="alarmasPendientes.length">
            <tr v-for="item in alarmasPendientes" :key="item.fecha+item.descripcion">
                <td style="padding: 4px;">
                    <v-card @click="rowClick(item)" ripple dark :color="colorForItem(item)" style="padding: 0 8px;">
                        <Alarma :id="item.id" :cuenta="item.query" :descripcion="item.descripcion" :fecha="item.fecha"/>
                    </v-card>
                </td>
            </tr>
        </tbody>
        <tbody v-else>
            <tr >
                <td style="padding: 4px;">
                    <v-card  dark color="primary" style="padding: 0 8px;">
                        <v-card-text>
                            No hay {{title.toLowerCase()}}
                        </v-card-text>
                    </v-card>
                </td>
            </tr>
        </tbody>
      </template>
    </v-data-table>
    </ScrollableVueCard>
</template>


<script>
import ScrollableVueCard from '@/components/ScrollableVueCard/ScrollableVueCard.vue'
import Alarma from '@/components/ListaBusqueda/Alarma/Alarma.vue'
import {AlertType, AlertStatus} from '@/views/helpers'
import store from '@/store'

export default {
    name: 'ComponenteHistorial',
    props:{
        title: String,
        pendientes: Boolean
    },
    components:{
        Alarma,
        ScrollableVueCard
    },
    data: () => ({
        AlertType
    }),
    methods:{
        colorForItem(item){
            switch(item.tipo){
                case AlertType.BLUE: return "#6495ED"
                case AlertType.YELLOW: return "#BDB76B"
                case AlertType.GREEN: return "#32CD32"
                case AlertType.RED: return "#FF0000"
            }
        },
        rowClick(value) {
            this.$emit('recent-query', value);
        }
    },
    computed:{
        alarmasPendientes(){
            if (!this.$store.state.alarmas){
                //console.log("vacias")
                return []
            }
            else{
                //console.log("llenas")

                return this.$store.state.alarmas
            }
        }
    }
}
</script>

<style scoped> 
</style>